export const HandleTableCells = {
  // props: {
  //   tableData: {
  //     type: Array,
  //     default: () => []
  //   }
  // },
  methods: {
    /**
     * 处理表格单元格
     * @param {object} info
     * @param {number} info.startChangeBgIndex  每一行从第几列开始隔行变色（列的下标）；
     * @param {number} info.colLength  总列数；
     * @param {number} info.mergeColIndex  需要合并的列（列的下标）
     * @param {string} info.ifNeedMergeCol  是否需要进行列合并（如果传'false',就不需要，否则需要）
     * @param {string} info.id  表格容器的id
     * @param {number} translateY  表格纵向的偏移量，针对使用了virtualTable虚拟滚动表的，用于设置固定行的bottom值
     */
    mergeCells(info,translateY) {
      console.log('单元格处理',info,translateY);
      info.startChangeBgIndex  = info.startChangeBgIndex || info.startChangeBgIndex == 0  ? info.startChangeBgIndex : 1
      translateY = translateY ? translateY + 'px' : '0px'
      // 一行的列数
      var colLength = info.colLength
      var val, count, start,colIndex;
      // 所有行，不含表头
      var rowClass = info.rowClass ? info.rowClass : 
                     info.id ? `#${info.id} .ant-table-scroll .ant-table-tbody tr` : '.ant-table-scroll .ant-table-tbody tr'
      var rows = Array.from(document.querySelectorAll(rowClass))
      // 左侧固定行
      var fixedRows = info.fixedRows ? info.fixedRows : Array.from(document.querySelectorAll(".ant-table-fixed-left .ant-table-tbody tr"))
      // 左侧固定行 一行的列数
      var fixedColLength = fixedRows.length > 0 ? fixedRows[0].cells.length : 0

      // 每次处理单元格之前先初始化所有样式，防止表格之间的样式污染
      this.resetTableStyle(colLength,rows)
      this.resetTableStyle(fixedColLength,fixedRows)

      // 【1】合并行(rowSpan设置)  纵向比较，先遍历列，把这列的所有行遍历结束再继续遍历下一列
      // 只处理需要合并的列，根据 fixedRows.length 判断有没有固定行，如果有，因为固定行是覆盖在非固定行上展示的，只需要对固定行的单元格进行 行/列合并
        
      // 该遍历一定执行，在该遍历里，需要做的处理：1. 隔行变色  2. 如果没有固定行，需要做单元格合并处理
      for (var col = 0; col < colLength; col++) {
        count = 1;
        val = "";
        for (var row = 0; row < rows.length; row++) {
          // 没有固定行
          if(fixedRows.length === 0){
            if(info.mergeColIndex && info.mergeColIndex.length > 0){
              // 判断这一列是否需要做合并处理
              if(info.mergeColIndex.indexOf(col) > -1){
                let prevEle = rows[row].cells[col].previousElementSibling
                let canMerge = false
                if(!prevEle){
                  canMerge = true
                }else if(prevEle && prevEle.style.display == 'none'){
                  canMerge = true
                }
                // console.log('prevEle11',prevEle,rows[row].cells[col]);
                // console.log('prevEle22',this.removeSpace(val) == this.removeSpace(rows[row].cells[col].innerHTML),canMerge,count);
                if (this.removeSpace(val) && this.removeSpace(val) == this.removeSpace(rows[row].cells[col].innerHTML) && canMerge) {
                  count++;
                } else {
                  if (count > 1) {
                    start = row - count;
                    rows[start].cells[col].rowSpan = count;
                    for (var j = start + 1; j < row; j++) {
                      rows[j].cells[col].style.display = "none";
                    }
                    count = 1;
                  }
                  val = rows[row].cells[col].innerHTML;
                }
              }
            }
          }

          // 设置小计行样式
          this.setSummaryTrStyle(rows,row,col)

          // 从第几列开始隔行变色
          if(row % 2 === 1){
            let targetCells = Array.from(rows[row].cells)
            targetCells.map((cell,index) => {
              if(index > info.startChangeBgIndex){
                cell.classList.add('oddCell')
              }
            })
          }
        }
        if (count > 1) { 
          //合并，最后几行相同的情况下
          start = row - count;
          rows[start].cells[col].rowSpan = count;
          for (var j = start + 1; j < row; j++) {
            rows[j].cells[col].style.display = "none";
          }
        }
      }

      // 有左侧固定行，执行该遍历，做单元格合并处理
      if(fixedRows.length > 0){
        for (var col = 0; col < fixedColLength; col++) {
          count = 1;
          val = "";
          for (var fixedRow = 0; fixedRow < fixedRows.length; fixedRow++) {
            if(info.mergeColIndex && info.mergeColIndex.length > 0){
              // 判断这一列是否需要做合并处理
              if(info.mergeColIndex.indexOf(col) > -1){
                if (this.removeSpace(val) && this.removeSpace(val) == this.removeSpace(fixedRows[fixedRow].cells[col].innerHTML)) {
                  count++;
                } else {
                  if (count > 1) {
                    start = fixedRow - count;
                    fixedRows[start].cells[col].rowSpan = count;
                    for (var j = start + 1; j < fixedRow; j++) {
                      fixedRows[j].cells[col].style.display = "none";
                    }
                    count = 1;
                  }
                  val = fixedRows[fixedRow].cells[col].innerHTML;
                }
              }
            }
            // 设置小计行样式
            this.setSummaryTrStyle(fixedRows,fixedRow,col)
          }
          if (count > 1) { 
            //合并，最后几行相同的情况下
            start = fixedRow - count;
            fixedRows[start].cells[col].rowSpan = count;
            for (var j = start + 1; j < fixedRow; j++) {
              fixedRows[j].cells[col].style.display = "none";
            }
          }
        }
      }

      // 【2】合并列(colSpan设置)  横向比较，先遍历行，把这行的所有列遍历结束再继续遍历下一行
      // 该遍历一定执行，在该遍历里，需要做的处理：1. 把每个单元格的display colSpan都初始化  2. 判断有没有固定行，有就取固定行遍历，做合并处理；没有就取普通行做合并处理
      if(!info.ifNeedMergeCol){
        var targetRows = fixedRows.length > 0 ? fixedRows : rows
        var targetColLength = fixedRows.length > 0 ? fixedColLength : colLength
        for(var row = 0; row < targetRows.length; row++){
          colIndex = 0
          val = ''
          count = 1
          for(var col = 0; col < targetColLength; col++){
            // 表格虚拟滚动，滚动后的表格样式会延续滚动前的样式，需要手动重置一下
            targetRows[row].cells[col].colSpan = 1
  
            if(info.mergeColIndex && info.mergeColIndex.length > 0){
              // 判断这一列是否需要做合并处理
              if(info.mergeColIndex.indexOf(col) > -1){
                colIndex = col
                if(this.removeSpace(val) && this.removeSpace(val) == this.removeSpace(targetRows[row].cells[col].innerHTML)){
                  count++
                }else{
                  if (count > 1) {
                    start = col - count;
                    targetRows[row].cells[start].colSpan = count;
                    for (var j = start + 1; j < col; j++) {
                      targetRows[row].cells[j].style.display = "none";
                    }
                    count = 1;
                  }
                  val = targetRows[row].cells[col].innerHTML;
                }
              }
            }
          }
          // if (count > 1) {
          //   start = col - count;
          //   targetRows[row].cells[0].colSpan = count;
          //   for (var j = 1; j < info.mergeColIndex.length; j++) {
          //     targetRows[row].cells[j].style.display = "none";
          //   }
          // }
          if (count > 1) {
            start = colIndex - count + 1;
            targetRows[row].cells[start].colSpan = count;
            for (var j = start + 1; j <= colIndex; j++) {
              targetRows[row].cells[j].style.display = "none";
            }
          }
        }
      }

      // 如果最后一列是固定列  设置隔行变色
      var fixedTds = Array.from(document.querySelectorAll(".ant-table-fixed-right .ant-table-tbody tr td"))
      if(fixedTds.length > 0){
        fixedTds.map((row,index) => {
          if(index % 2 === 1){
            row.classList.add('oddCell')
          }
        })
      }

      // 如果最后一行是合计行，设置样式并固定到表格底部
      let lastRow = rows[rows.length - 1]
      let fixedLastRow = fixedRows[fixedRows.length - 1]
      this.stickyLastTotalRow(colLength,lastRow,translateY)
      this.stickyLastTotalRow(fixedColLength,fixedLastRow,translateY)

      // 解决表格向右拖动，表头和表体错位的问题：判断表体有没有产生滚动条，产生了，就把表头宽度减去滚动条宽度
      this.$nextTick(() => {
        var tableBody = document.querySelector('.ant-table-scroll .ant-table-body')
        var tableHeader = document.querySelector('.ant-spin-container > .ant-table > .ant-table-content > .ant-table-scroll > .ant-table-header')
        if(tableBody){
          // offsetWidth < scrollWidth  说明有横向滚动条
          // offsetHeight < scrollHeight  说明有纵向滚动条
          if(tableBody.offsetHeight < tableBody.scrollHeight && tableBody.offsetWidth < tableBody.scrollWidth){
            // 产生了横向和纵向滚动条
            tableHeader.style.width = 'calc(100% - 7px)'
          }else{
            tableHeader.style.width = '100%'
          }
        }
      })
    },
    // 字符串左右两边去空格
    // 接口返回的字符串，例如 '沛县' 有时候又是'沛县 '，前端做个处理
    removeSpace(data){
      if(typeof(data) == 'string'){
        return data.trim()
      }else{
        return data
      }
    },

    // 设置 小计\合计\总计 行样式
    setSummaryTrStyle(rows,rowIndex,colIndex){
      if(['小计', '合计', '总计'].some(item => rows[rowIndex].cells[colIndex].innerHTML.includes(item))){
        let targetCells = Array.from(rows[rowIndex].cells)
        targetCells.map(cell => {
          cell.style.color = '#fff'
        })
      }
    },

    // 固定最后一行合计行
    stickyLastTotalRow(colLength,row,translateY){
      // 判断是不是合计行
      let ifSummaryTr = false
      for(let i = 0; i < colLength; i++){
        if(['合计', '总计'].some(item => row.cells[i].innerHTML.includes(item))){
          ifSummaryTr= true
        }
      }
      if(ifSummaryTr){
        // 给这行的每个td加class类标识
        for(let i = 0; i < colLength; i++){
          row.cells[i].classList.add('stickyTd')
        }
        // 给这个class加纵向偏移量
        let stickyTds = Array.from(document.querySelectorAll('.stickyTd'))
        stickyTds.map(item => {
          item.style.bottom = translateY
        })
      }
    },

    // 隔行变色
    changeOddTrBg(){
      var rows = Array.from(document.querySelectorAll(".ant-table-scroll .ant-table-tbody tr"))
      if(rows.length > 0){
        rows.map((row,index) => {
          if(index % 2 === 1){
            let targetCells = Array.from(row.cells)
            targetCells.map(cell => {
              cell.classList.add('oddCell')
            })
          }
        })
      }
    },

    // 每次处理单元格之前先初始化所有样式，防止表格之间的样式污染
    resetTableStyle(colLength,rows){
      for (var col = 0; col < colLength; col++) {
        for (var row = 0; row < rows.length; row++) {
          if(rows[row].cells[col]){
            // 重置单元格合并
            rows[row].cells[col].style.display = ''
            rows[row].cells[col].rowSpan = 1
            // 重置单元格字体颜色
            rows[row].cells[col].style.color = 'rgba(255, 255, 255, 0.5)'
            // 移除所有固定行样式
            rows[row].cells[col].classList.remove('stickyTd')
          }
        }
      }
    },
  },
}